// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1GckV","info":"PatientInfo_info__xppIr"};